import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import API_URLS from "../../summaryapi/apiUrls";
import { ToastContainer,toast } from "react-toastify";
const EmployeeReports = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    filterData();
  }, [search, fromDate, toDate, employees]);

  const fetchEmployees = async () => {
    try {
      const response = await fetch(API_URLS.getemployees.url);
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch employees");
      }

      if (result.status) {
        setEmployees(result.data);
        setFilteredEmployees(result.data);
      } else {

      }
    } catch (error) {

    }
  };
  const filterData = () => {
    let data = [...employees];

    if (search) {
      data = data.filter(
        (emp) =>
          emp.employee_name.toLowerCase().includes(search.toLowerCase()) ||
          emp.phone_number.includes(search)
      );
    }




    if (fromDate) {
      data = data.filter((emp) => {
        const studentDate = emp.created_date.split(" ")[0];
        return studentDate >= fromDate;
      });
    }

    if (toDate) {
      data = data.filter((emp) => {
        const studentDate = emp.created_date.split(" ")[0];
        return studentDate <= toDate;
      });
    }








    setFilteredEmployees(data);
    setCurrentPage(1);
  };

  const exportToExcel = () => {
    const dataForExport = filteredEmployees.map((emp, index) => {
      return {
        "S.No": index + 1,
        "Voluntary Name": emp.employee_name || "",
        "Phone": emp.phone_number || "",
        "Password": emp.password || "",
        "Additional Info": emp.additional_information || "",
        "Address": emp.address || "",
        "Active Status": emp.is_active === "1" ? "Yes" : "No",
        "Interested": emp.is_interested === "1" ? "Yes" : "No",
        "Students Enrolled": emp.total_students || "0",
        "Created Date": new Date(emp.created_date).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
        }),
      };
    });
  
    const ws = XLSX.utils.json_to_sheet(dataForExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Employees");
    XLSX.writeFile(wb, "EmployeeReports.xlsx");
  };
  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Voluntary Reports</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="border p-2 rounded-md w-full"
          placeholder="From Date"
        />
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="border p-2 rounded-md w-full"
          placeholder="To Date"
        />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name or phone"
          className="border p-2 rounded-md w-full"
        />
        <button
          onClick={exportToExcel}
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md w-full"
        >
          Download Excel
        </button>
      </div>

      <div className="">
        <table className="min-w-full divide-y divide-gray-200 bg-white text-center border">
          <thead className="bg-gray-50 text-gray-700 text-sm">
            <tr>
              <th className="px-4 py-3 text-center">ID</th>
              <th className="px-4 py-3 text-center">Name</th>
              <th className="px-4 py-3 text-center">Phone</th>
              <th className="px-4 py-3 text-center">Password</th>
              <th className="px-4 py-3 text-center">Additional Info</th>
              <th className="px-4 py-3 text-center">Address</th>
              <th className="px-4 py-3 text-center">Status</th>
              <th className="px-4 py-3 text-center">Students Enrolled</th>
              <th className="px-4 py-3 text-center">Created Date</th>
            </tr>
          </thead>
          <tbody className="text-gray-700 text-sm divide-y divide-gray-100">
            {currentItems.length > 0 ? (
              currentItems.map((emp) => (
                <tr key={emp.employee_id}>
                  <td className="px-4 py-3">{emp.employee_id}</td>
                  <td className="px-4 py-3">{emp.employee_name}</td>
                  <td className="px-4 py-3">{emp.phone_number}</td>
                  <td className="px-4 py-3">{emp.password}</td>
                  <td className="px-4 py-3">{emp.additional_information}</td>
                  <td className="px-4 py-3">{emp.address}</td>
                  <td className="px-4 py-3">
                    {emp.is_active === "1" ? "Active" : "Inactive"}
                  </td>
                  <td className="px-4 py-3">{emp.total_students}</td>

                  


                  <td className="px-4 py-3">
  {new Date(emp.created_date).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4 text-gray-500">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td
                colSpan="8"
                className="px-4 py-3 text-right text-sm text-gray-500"
              >
                Total Records: {filteredEmployees.length}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex flex-wrap justify-center mt-6 gap-2">
          {Array.from({ length: totalPages }, (_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentPage(idx + 1)}
              className={`px-3 py-1 rounded-md border text-sm ${
                currentPage === idx + 1
                  ? "bg-blue-500 text-white"
                  : "bg-white text-gray-700 hover:bg-gray-100"
              }`}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmployeeReports;
